// extracted by mini-css-extract-plugin
module.exports = {"notice":"NoticeBox_notice__AishS","notice_title":"NoticeBox_notice_title___GV7C","notice_list":"NoticeBox_notice_list__gkmzF"};